import { useMorphemePanelsHrefNavigator } from "@-/dev.improve.haniverse.lib.morpheme.page.navigator";
import type { MorphemeHrefObject } from "@-/dev.improve.haniverse.lib.morpheme.href.entities";
import { useCallback, useContext } from "react";
import { GraphemePreviewSheetContext } from "#grapheme-preview-sheet-context";

/**
 * How a tap on a bracketed mnemonic link should resolve.
 *
 * Prefers the preview sheet so the reader keeps the character they were studying, and falls back
 * to a real navigation on surfaces that mount no sheet (the Reference page, review cards).
 */
export function useGraphemeLinkPress({ prefix }: { prefix: MorphemeHrefObject }) {
  const previewSheet = useContext(GraphemePreviewSheetContext);
  const cardPageNavigator = useMorphemePanelsHrefNavigator();

  return useCallback(
    (grapheme: string) => {
      if (previewSheet !== null) {
        previewSheet.openGraphemePreview(grapheme);
        return;
      }
      cardPageNavigator.push.mutate({ morpheme: grapheme, prefix });
    },
    [cardPageNavigator, prefix, previewSheet],
  );
}
